
export const ROLES = {
  1: 'Super Admin',
  2: 'Company Admin',
  3: 'Driver',
  4: 'Dispatcher',
  5: 'Accountant',
  6: 'Client',
  7: 'Agent',
};

export const SET_ROLES = [
  { label: 'Admin', value: 2 },
  { label: 'Driver', value: 3 },
  { label: 'Dispatcher', value: 4 },
  { label: 'Accountant', value: 5 },
  { label: 'Client', value: 6 },
];
